// MODULES
import React from "react";

// HELPERS
import {createClassName, getPropertiesByPrefix, parseDraftDataPropsToFieldState, delay} from "@helpers/utils";
import fulfillmentCheck from "./KycJuridiskPerson.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import OptionsList from "../../../components/OptionsList/OptionsList";
import EditableField from "../../../components/EditableField/EditableField";
import Select from "../../../../../components/Select/Select";
import countries from "@helpers/countries";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";

const countriesOptions = countries.map(({label, code}) => ({label, value: code}));

export default class KycJuridiskPerson extends React.PureComponent {
	static companyExclusive = true;
	static privateExclusive = false;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}

    if (prevProps.draftData !== props.draftData) {
      if (props.draftData) {
        const draftDataProps = getPropertiesByPrefix(props.draftData, ['futur_kyc_juridisk', 'futur_kyc_']);
        const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);
        
        this.setState(
          {
            fields: {...newFieldsState}
          },
          async () => {          
              await delay(200);
              onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
          }
        );
      }
		}
	}

	render() {
		const {props, state} = this;
		const {title} = props;

		const classes = createClassName("Cob-Fees", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		let selectedTaxCountryIndex = -1;
		for (let i = 0; i < countriesOptions.length; i++) {
			if (state.fields.futur_kyc_juridisk_tax_residency_country === countriesOptions[i].value) {
				selectedTaxCountryIndex = i;
				break;
			}
		}

		const checkedSources = [];
		state.fields.futur_kyc_juridisk_source.options.forEach(function (o) {
			if (o.checked) {
				checkedSources.push(o.value);
			}
		});

		const checkedListingType = [];
		state.fields.futur_kyc_juridisk_is_listed.options.forEach(function (o) {
			if (o.checked) {
				checkedListingType.push(o.value);
			}
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>


					<h4 style={{fontWeight: "600", marginBottom: "10px"}}>Varifrån kommer inbetalningarna till
						försäkringen? </h4>

					<OptionsList
						type="checkbox"
						orientation="vertical"
						name="futur_kyc_juridisk_source"
						options={state.fields.futur_kyc_juridisk_source.options}
						onChange={this._onOptionsListChange}
					/>

					<input type="hidden" name="futur_kyc_juridisk_source" value={checkedSources.join(",")}/>

					{state.fields.futur_kyc_juridisk_source.options[5].checked && (
						<EditableField
							name="futur_kyc_juridisk_source_other"
							label="Ange"
							value={state.fields.futur_kyc_juridisk_source_other}
							valid={state.validFields.futur_kyc_juridisk_source_other}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							style={{marginTop: "10px", maxWidth: "300px"}}
						/>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Har företaget skattehemvist i annat land än Sverige?"}
						name="futur_kyc_juridisk_is_foreign"
						options={state.fields.futur_kyc_juridisk_is_foreign.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_kyc_juridisk_is_foreign.options[1].checked && (
						<div style={{display: "block", marginTop: "20px", width: "100%"}}>
							<h4 style={{fontWeight: "600", marginBottom: "10px"}}>Försäkringstagarens skattehemvist (om
								annat än Sverige)</h4>

							<Select
								name={"futur_kyc_juridisk_tax_residency_country"}
								label="Ange"
								options={countriesOptions}
								selectedIndex={selectedTaxCountryIndex}
								onChange={this._onSelectChange}
								style={{maxWidth: "300px"}}
							/>

							<h4 style={{marginTop: "30px", fontWeight: "600", marginBottom: "10px"}}>Ange TIN i land där
								ovanstående har skattehemvist</h4>
							<EditableField
								name="futur_kyc_juridisk_tax_residency_tin"
								label="Ange TIN"
								value={state.fields.futur_kyc_juridisk_tax_residency_tin_missing.checked ? "" : state.fields.futur_kyc_juridisk_tax_residency_tin}
								valid={state.validFields.futur_kyc_juridisk_tax_residency_tin}
								onChange={this._onFieldChange}
								onBlur={this._onFieldBlur}
								disabled={state.fields.futur_kyc_juridisk_tax_residency_tin_missing.checked}
								style={{maxWidth: "200px"}}
							/>

							<CheckboxWithName
								label="TIN kan inte anges"
								name="futur_kyc_juridisk_tax_residency_tin_missing"
								value={state.fields.futur_kyc_juridisk_tax_residency_tin_missing.checked}
								checked={state.fields.futur_kyc_juridisk_tax_residency_tin_missing.checked}
								onChange={this._onCheckboxChange}
								style={{margin: "10px 0", justifyContent: "flex-start"}}
							/>

							{state.fields.futur_kyc_juridisk_tax_residency_tin_missing.checked && (
								<React.Fragment>
									<OptionsList
										type="radio"
										orientation="horizontal"
										description={"Uppge anledning till varför TIN saknas"}
										name="futur_kyc_juridisk_tax_residency_tin_missing_reason"
										options={state.fields.futur_kyc_juridisk_tax_residency_tin_missing_reason.options}
										onChange={this._onOptionsListChange}
										style={{marginTop: "20px", marginBottom: "15px"}}
									/>

									{state.fields.futur_kyc_juridisk_tax_residency_tin_missing_reason.options[1].checked && (
										<EditableField
											name="futur_kyc_juridisk_tax_residency_tin_missing_reason_other"
											label="Ange anledning"
											value={state.fields.futur_kyc_juridisk_tax_residency_tin_missing_reason_other}
											valid={state.validFields.futur_kyc_juridisk_tax_residency_tin_missing_reason_other}
											onChange={this._onFieldChange}
											onBlur={this._onFieldBlur}
										/>
									)}
								</React.Fragment>
							)}
						</div>
					)}

					<h4 style={{fontWeight: "600", marginTop: "40px", marginBottom: "10px"}}>Typ av företag?</h4>

					<OptionsList
						type="radio"
						orientation="vertical"
						name="futur_kyc_juridisk_type"
						options={state.fields.futur_kyc_juridisk_type.options}
						onChange={this._onOptionsListChange}
					/>

					{state.fields.futur_kyc_juridisk_type.options[5].checked && (
						<OptionsList
							type="radio"
							orientation="horizontal"
							description={"Är bolaget passivt?"}
							name="futur_kyc_juridisk_passive"
							options={state.fields.futur_kyc_juridisk_passive.options}
							onChange={this._onOptionsListChange}
							style={{marginTop: "20px"}}
						/>
					)}

					{state.fields.futur_kyc_juridisk_type.options[5].checked && state.fields.futur_kyc_juridisk_passive.options[0].checked && (
						<p style={{
							background: "#ffe5e5",
							padding: "10px",
							fontWeight: "bold",
							maxWidth: "600px"
						}}>
							Du har markerat att bolaget är aktivt, vänligen välj någon av ovanstående bolagstyper istället
							(ej <i>Annat bolag</i>).
						</p>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Har företaget några verkliga huvudmän som har skattehemvist utanför Sverige?"}
						name="futur_kyc_bo_outside_sweden"
						options={state.fields.futur_kyc_bo_outside_sweden.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_kyc_bo_outside_sweden.options[1].checked && (
						<p style={{
							background: "#ffe5e5",
							padding: "10px",
							fontWeight: "bold",
							maxWidth: "600px"
						}}>
							Tyvärr kan din ansökan inte godkännas automatiskt i dagsläget.<br />
							Var god kontakta backoffice.
						</p>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Har företaget några verkliga huvudmän som är U.S. persons?"}
						name="futur_kyc_bo_us_persons"
						options={state.fields.futur_kyc_bo_us_persons.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_kyc_bo_us_persons.options[1].checked && (
						<p style={{
							background: "#ffe5e5",
							padding: "10px",
							fontWeight: "bold",
							maxWidth: "600px"
						}}>
							Tyvärr kan din ansökan inte godkännas automatiskt i dagsläget.<br />
							Var god kontakta backoffice.
						</p>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Är bolaget börsnoterat eller dotterbolag till noterat bolag?"}
						name="futur_kyc_listed_question"
						options={state.fields.futur_kyc_listed_question.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_kyc_listed_question.options[1].checked && (
						<OptionsList
							type="checkbox"
							orientation="vertical"
							name="futur_kyc_juridisk_is_listed"
							options={state.fields.futur_kyc_juridisk_is_listed.options}
							onChange={this._onOptionsListChange}
							style={{marginTop: "10px"}}
						/>
					)}

					<input type="hidden" name="futur_kyc_juridisk_is_listed" value={checkedListingType.join(",")}/>

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Finns juridisk person som, direkt eller indirekt, äger eller kontrollerar mer än 25 procent?"}
						name="futur_kyc_juridisk_has_bo"
						options={state.fields.futur_kyc_juridisk_has_bo.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_kyc_juridisk_has_bo.options[1].checked && (
						<OptionsList
							type="radio"
							orientation="horizontal"
							description={"Ägs den juridiska personen [som åsyftas ovan] till 100% genom direktägande av endast en fysisk person?"}
							name="futur_kyc_juridisk_100_owned"
							options={state.fields.futur_kyc_juridisk_100_owned.options}
							onChange={this._onOptionsListChange}
							style={{marginTop: "40px"}}
						/>
					)}

				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) => {
		return value.length > 0;
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};

	_onSelectChange = (option, index) => {
		CobHelpers.onViewFieldChange.call(this, "futur_kyc_juridisk_tax_residency_country", option.value);
	};

	_onOptionsListChange = ({type, name}, option, index) => {
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions,
				},
			},
		}, () => fulfillmentCheck(this.props, this.state));
	};
}

function _getFields() {
	return [
		"futur_kyc_juridisk_source",
		"futur_kyc_juridisk_source_other",
		"futur_kyc_juridisk_type",
		"futur_kyc_juridisk_is_listed",
		"futur_kyc_juridisk_is_foreign",
		"futur_kyc_juridisk_has_bo",
		"futur_kyc_juridisk_passive",
		"futur_kyc_juridisk_tax_residency_country",
		"futur_kyc_juridisk_tax_residency_tin",
		"futur_kyc_juridisk_tax_residency_tin_missing",
		"futur_kyc_juridisk_tax_residency_tin_missing_reason",
		"futur_kyc_juridisk_tax_residency_tin_missing_reason_other",
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};

	return {
		validFields: {},
		fields: {
			futur_kyc_juridisk_source: {
				options: [
					{label: "Företagets löpande verksamhet", value: "OngoingBusiness", checked: false},
					{label: "Bolagsförsäljning", value: "CorporationSale", checked: false},
					{label: "Avkastning från investering", value: "ReturnOnInvestment", checked: false},
					{label: "Utdelningar från företaget", value: "Dividends", checked: false},
					{label: "Fastighetsförsäljning", value: "PropertySale", checked: false},
					{label: "Annat", value: "Other", checked: false}
				]
			},
			futur_kyc_juridisk_source_other: "",

			futur_kyc_juridisk_tax_residency_country: "",
			futur_kyc_juridisk_tax_residency_tin: "",

			futur_kyc_juridisk_tax_residency_tin_missing: {
				checked: false
			},

			futur_kyc_juridisk_tax_residency_tin_missing_reason: {
				options: [
					{label: "Landet utfärdar ej TIN", value: "not_issued", checked: false},
					{label: "Annan anledning", value: "other", checked: false}
				]
			},

			futur_kyc_juridisk_tax_residency_tin_missing_reason_other: "",

			futur_kyc_juridisk_type: {
				options: [
					{label: "Bedriver näringsverksamhet", value: "ActiveBusiness", checked: false},
					{label: "Finansiellt institut", value: "FinancialInstitute", checked: false},
					{label: "Börsnoterat bolag", value: "ListedCompany", checked: false},
					{label: "Nystartat bolag", value: "NewlyStarted", checked: false},
					{label: "Välgörenhetsorganisation", value: "Charity", checked: false},
					{label: "Annat bolag", value: "Other", checked: false}
				]
			},

			futur_kyc_juridisk_is_listed: {
				options: [
					{label: "Bolaget är börsnoterat", value: "listed", checked: false},
					{
						label: "Bolaget är dotterbolag/majoritetsägt av ett börsnoterat bolag",
						value: "owned",
						checked: false
					}
				]
			},

			futur_kyc_juridisk_has_bo: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "ja", checked: false}
				]
			},

			futur_kyc_juridisk_100_owned: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "ja", checked: false}
				]
			},

			futur_kyc_juridisk_passive: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "ja", checked: false}
				]
			},

			futur_kyc_juridisk_is_foreign: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "ja", checked: false}
				]
			},

			futur_kyc_bo_outside_sweden: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "ja", checked: false}
				]
			},

			futur_kyc_listed_question: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "ja", checked: false}
				]
			},

			futur_kyc_bo_us_persons: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "ja", checked: false}
				]
			},
		}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/KycJuridiskPerson/KycJuridiskPerson.js